import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Loading from './components/Loading';
import Navbar from './components/Navbar';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/ProtectedRoute';
import AudioPlayer from './components/AudioPlayer';
import SnowEffect from './components/SnowEffect';
import ErrorBoundary from './components/ErrorBoundary';
import { useScrollToTop } from './hooks/useScrollToTop';

// Import pages
import Admin from './pages/Admin';
import Home from './pages/Home';
import Rules from './pages/Rules';
import Prizes from './pages/Prizes';
import Sponsors from './pages/Sponsors';
import TreeDetails from './pages/TreeDetails';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Terms from './pages/Terms';

const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
  useScrollToTop();
  return <>{children}</>;
};

const App = () => {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Router>
          <ScrollToTop>
            <div className="min-h-screen flex flex-col">
              <SnowEffect />
              <AudioPlayer />

              <Toaster 
                position="top-right"
                toastOptions={{
                  className: 'will-change-transform',
                  duration: 3000
                }} 
              />

              <Navbar />

              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/arbol/:slug" element={<TreeDetails />} />
                  <Route path="/reglas" element={<Rules />} />
                  <Route path="/premios" element={<Prizes />} />
                  <Route path="/patrocinadores" element={<Sponsors />} />
                  <Route path="/privacidad" element={<Privacy />} />
                  <Route path="/cookies" element={<Cookies />} />
                  <Route path="/bases-legales" element={<Terms />} />
                  <Route path="/login" element={<Login />} />
                  <Route 
                    path="/admin/*" 
                    element={
                      <ProtectedRoute>
                        <Admin />
                      </ProtectedRoute>
                    } 
                  />

                  {/* Legacy URL redirects */}
                  <Route path="/rules" element={<Navigate to="/reglas" replace />} />
                  <Route path="/prizes" element={<Navigate to="/premios" replace />} />
                  <Route path="/sponsors" element={<Navigate to="/patrocinadores" replace />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
            </div>
          </ScrollToTop>
        </Router>
      </ErrorBoundary>
    </HelmetProvider>
  );
};

export default App;